import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "cycleInsideCircle",
    iconColor: "white",
    text: "AI & Automation for \nclosed loop assurance",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "ai",
    iconColor: "white",
    text: "Gen AI for future\n networks",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_INTRO_ISNA = {
  title: "Smart Network \nOperations with AI",
  text: "Infosys Smart Network Assurance (ISNA) is an advanced network AI Ops \nsolution that combines Generative AI techniques with supervised and \nunsupervised AI/ ML models to observe, diagnose and self-heal network faults.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  styleListData: { marginTop: "24px" },
  next: {
    label: "FIND OUT HOW",
    onClick: () => setCurrentPage("ENG_202"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_1"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/ISNA/ISNA_Introduction_01.png",
};
